// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  padding: 40px 0;
  min-height: calc(100vh - 200px);
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 40px;
  padding-bottom: 15px;
  border-bottom: 3px solid #667eea;
}

.about-section {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.company-info {
  text-align: center;
  margin-bottom: 50px;
}

.company-info h2 {
  font-size: 32px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 10px;
}

.company-english {
  font-size: 20px;
  color: #6c757d;
  font-weight: 300;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 40px;
}

.info-item {
  padding: 25px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

.info-item h3 {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
}

.info-item p {
  font-size: 16px;
  line-height: 1.6;
  color: #495057;
}

.info-item ul {
  list-style: none;
  padding: 0;
}

.info-item ul li {
  font-size: 16px;
  line-height: 1.8;
  color: #495057;
  padding-left: 20px;
  position: relative;
}

.info-item ul li:before {
  content: "▸";
  position: absolute;
  left: 0;
  color: #667eea;
}

@media (max-width: 768px) {
  .about-section {
    padding: 25px;
  }
  
  .page-title {
    font-size: 28px;
  }
  
  .company-info h2 {
    font-size: 24px;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":[".about-page {\n  padding: 40px 0;\n  min-height: calc(100vh - 200px);\n}\n\n.page-title {\n  font-size: 36px;\n  font-weight: 700;\n  color: #2c3e50;\n  margin-bottom: 40px;\n  padding-bottom: 15px;\n  border-bottom: 3px solid #667eea;\n}\n\n.about-section {\n  background: white;\n  border-radius: 12px;\n  padding: 40px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.company-info {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.company-info h2 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #2c3e50;\n  margin-bottom: 10px;\n}\n\n.company-english {\n  font-size: 20px;\n  color: #6c757d;\n  font-weight: 300;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 40px;\n  margin-top: 40px;\n}\n\n.info-item {\n  padding: 25px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #667eea;\n}\n\n.info-item h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 15px;\n}\n\n.info-item p {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #495057;\n}\n\n.info-item ul {\n  list-style: none;\n  padding: 0;\n}\n\n.info-item ul li {\n  font-size: 16px;\n  line-height: 1.8;\n  color: #495057;\n  padding-left: 20px;\n  position: relative;\n}\n\n.info-item ul li:before {\n  content: \"▸\";\n  position: absolute;\n  left: 0;\n  color: #667eea;\n}\n\n@media (max-width: 768px) {\n  .about-section {\n    padding: 25px;\n  }\n  \n  .page-title {\n    font-size: 28px;\n  }\n  \n  .company-info h2 {\n    font-size: 24px;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n    gap: 25px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
